import { useCallback, useState } from "react";

const getWidthAndHeight = (file) => {
  return new Promise((resolve) => {
    const reader = new FileReader();

    // Read the contents of Image File.
    reader.readAsDataURL(file);

    reader.onload = function (e) {
      // Initiate the JavaScript Image object.
      const image = new Image();

      // Set the Base64 string return from FileReader as source.
      image.src = e.target.result;

      // Validate the File Height and Width.

      image.onload = function () {
        const { height, width } = this;

        resolve({ height, width });
      };
    };
  });
};

const useUploadHandlers = ({ onUpload, setItems }) => {
  const [isDragging, setIsDragging] = useState(false);
  const [uploadingImages, setUploadingImages] = useState([]);

  const handleUpload = useCallback(
    async (files) => {
      const filesWithDimensions = await Promise.all(
        files.map(async (file, index) => {
          const { height, width } = await getWidthAndHeight(file);

          return {
            file,
            height,
            width,
            id: `${file.name}-${index}`,
            src: URL.createObjectURL(file),
          };
        })
      );

      setUploadingImages((prevUploadingImages) => [
        ...filesWithDimensions,
        ...prevUploadingImages,
      ]);

      const uploadedImages = await onUpload(filesWithDimensions);

      setItems((prevItems) => [...uploadedImages, ...prevItems]);

      const newImageIds = new Set(filesWithDimensions.map((f) => f.id));

      setUploadingImages((prevUploadingImages) => [
        ...prevUploadingImages.filter((image) => !newImageIds.has(image.id)),
      ]);
    },
    [onUpload, setItems]
  );

  const handleFileChange = useCallback(
    async (e) => {
      if (!onUpload) {
        return;
      }

      handleUpload(Array.from(e.target.files));
    },
    [handleUpload, onUpload]
  );

  const handleDrop = useCallback(
    (e) => {
      if (!onUpload) {
        return;
      }

      e.preventDefault();
      handleUpload(Array.from(e.dataTransfer.files));

      setIsDragging(false);
    },
    [handleUpload, onUpload]
  );

  const handleDragOver = useCallback((e) => {
    e.preventDefault();
    setIsDragging(true);
  }, []);

  const handleDragLeave = useCallback(() => {
    setIsDragging(false);
  }, []);

  return {
    handleFileChange,
    handleDrop,
    handleDragOver,
    handleDragLeave,
    isDragging,
    uploadingImages,
  };
};

export default useUploadHandlers;
